import { ProposalTypeByCode } from "@repo/core/constants/proposals";
import { mapCreditProposalToSavePayload } from "@repo/core/screens/ProposalEffectiveFlows/Credit/hooks/useCreditProposal/mappers";
import {
  ConsultProposalResponseDTO,
  PROPOSTA_SITUACAO,
  TIPO_PESSOA,
  UpdateProposalInputDTO
} from "@repo/core/services/entities/Proposals";
import { MobileProposalResource } from "@repo/core/services/resources/mobile-proposal";
import { ProposalsResource } from "@repo/core/services/resources/proposals";
import { fetchMobileConsultProposalMergedWithDetailsName } from "@repo/core/utils/proposalClientName.utils";

type EffectuateRejectedFidelityProposalInput = {
  lngProposta: string;
  mobileProposalResource: MobileProposalResource;
  proposalsResource: ProposalsResource;
};

export const buildRejectedFidelityProposalAlterPayload = (
  proposal: Partial<ConsultProposalResponseDTO>
): UpdateProposalInputDTO => {
  const proposalWithoutCnhImages = { ...proposal };
  delete proposalWithoutCnhImages.imgCnhFrente;
  delete proposalWithoutCnhImages.imgCnhVerso;

  const creditPayload = mapCreditProposalToSavePayload(
    proposalWithoutCnhImages
  );

  return {
    ...proposalWithoutCnhImages,
    ...creditPayload,
    lngProposta: String(proposal.lngProposta),
    strSituacao: PROPOSTA_SITUACAO.APPROVED_AUTOMATICALLY,
    strTipoProposta: ProposalTypeByCode.FIDELIDADE,
    strTipoPessoa: TIPO_PESSOA.FISICA,
    strReavaliacaoLimite:
      proposal.strReavaliacaoLimite || creditPayload.strReavaliacaoLimite,
    intDiaCartao: 1,
    blnManterPendente: false
  };
};

export const effectuateRejectedFidelityProposal = async ({
  lngProposta,
  mobileProposalResource,
  proposalsResource
}: EffectuateRejectedFidelityProposalInput) => {
  const proposal = await fetchMobileConsultProposalMergedWithDetailsName(
    mobileProposalResource,
    proposalsResource,
    lngProposta
  );

  const situation = await proposalsResource.getProposalSituation(lngProposta);
  const payload = buildRejectedFidelityProposalAlterPayload(proposal);
  payload.strReavaliacaoLimite =
    situation.data.strReavaliacaoLimite || payload.strReavaliacaoLimite;

  await proposalsResource.editProposal(payload);

  return proposalsResource.effectuateProposalWithBody(lngProposta);
};
